import { concatClassnames } from "shared/utils/concatClassnames";
import Text from "shared/ui/typography/Text";
import Container from "shared/ui/container";
import { OrderProduct, Product } from "shared/api/middleware-api-client";
import ProductItemSidebar from "entities/product-item-sidebar";
import { zakelijkDoorCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import ZakelijkProductItemSidebar from "widgets/checkout/door-list/ZakelijkProductItemSidebar";

interface SidebarProductsListProps {
  products: Product[] | OrderProduct[];
}
const SidebarProductsList = ({ products }: SidebarProductsListProps) => {
  return (
    <>
      {products.length ? (
        products.map((product, id) => {
          const isZakelijkProduct = zakelijkDoorCodes.includes(
            "doorType" in product ? product.doorType.code : "",
          );
          return (
            <div
              key={`product-${id}`}
              className={concatClassnames(
                "gg-grid gg-grid-cols-12 gg-items-start",
                id !== products.length - 1 && "gg-border-b",
                id !== 0 && "gg-pt-9",
                id !== products.length - 1 ? "gg-pb-9" : "gg-pb-2",
              )}
            >
              {!isZakelijkProduct ? (
                <ProductItemSidebar product={product} />
              ) : (
                <ZakelijkProductItemSidebar product={product as Product} />
              )}
            </div>
          );
        })
      ) : (
        <Container className="gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
          <Text>Geen products.</Text>
        </Container>
      )}
    </>
  );
};
export default SidebarProductsList;
